export const vi = {
  common: {
    loadError: 'Không tải được dữ liệu',
    retry: 'Thử lại',
    search: 'Tìm theo số, tiêu đề…',
    columns: 'Cột',
    export: 'Xuất CSV',
    cancel: 'Huỷ',
    save: 'Lưu',
    saved: 'Đã lưu',
    delete: 'Xoá',
    add: 'Thêm',
    none: '—',
    nobody: 'Chưa giao',
  },
  status: {
    todo: 'Cần làm',
    doing: 'Đang làm',
    review: 'Chờ kiểm tra',
    done: 'Xong',
    cancelled: 'Huỷ',
  },
  move: {
    todo: 'Chuyển về Cần làm',
    doing: 'Bắt đầu làm',
    review: 'Gửi kiểm tra',
    done: 'Hoàn thành',
    cancelled: 'Huỷ việc',
    returnTitle: 'Trả lại việc',
    reopen: 'Mở lại',
    returnHint: 'Ghi điều cần sửa; người phụ trách sẽ nhận thông báo.',
    reason: 'Lý do',
    notAllowed: 'Bạn không chuyển được việc sang cột này.',
  },
  priority: { low: 'Thấp', normal: 'Thường', high: 'Cao', urgent: 'Gấp' },
  mine: {
    title: 'Việc của tôi',
    description: 'Việc bạn phụ trách, việc bạn giao và việc bạn theo dõi, ở mọi dự án.',
    assigned: 'Tôi phụ trách',
    created: 'Tôi giao',
    watching: 'Đang theo dõi',
    recurring: 'Lặp lại',
    overdue: 'Quá hạn',
    today: 'Hôm nay',
    upcoming: 'Sắp tới',
    noDue: 'Không có hạn',
    empty: 'Không có việc nào',
    showDone: 'Gồm việc đã xong',
  },
  projects: {
    title: 'Dự án',
    description: 'Dự án bạn tham gia hoặc được xem.',
    new: 'Tạo dự án',
    edit: 'Sửa dự án',
    key: 'Mã dự án',
    keyHint: '2–6 chữ in hoa hoặc số, dùng làm tiền tố số việc (MKT-12).',
    name: 'Tên dự án',
    descriptionField: 'Mô tả',
    unit: 'Đơn vị sở hữu',
    unitHint: 'Trưởng đơn vị được xem dự án.',
    public: 'Công khai trong công ty',
    publicHint: 'Mọi người xem và bình luận được; chỉ thành viên tạo và làm việc.',
    archived: 'Lưu trữ',
    showArchived: 'Gồm dự án đã lưu trữ',
    empty: 'Chưa có dự án nào',
    managers: 'Quản lý',
    open: 'Đang mở',
    overdueCount: '{{count}} quá hạn',
    progress: '{{done}}/{{total}} việc xong',
    created: 'Đã tạo dự án',
    roles: { manager: 'Quản lý dự án', member: 'Thành viên' },
    viewer: 'Người xem',
  },
  project: {
    board: 'Kanban',
    list: 'Danh sách',
    settings: 'Thành viên & cài đặt',
    members: 'Thành viên',
    addMember: 'Thêm thành viên…',
    labels: 'Nhãn',
    addLabel: 'Thêm nhãn',
    labelName: 'Tên nhãn',
    newTask: 'Thêm việc',
    quickAdd: 'Thêm việc vào cột này…',
    readOnly: 'Bạn đang xem dự án này (không phải thành viên).',
    filterAssignee: 'Mọi người',
    filterLabel: 'Mọi nhãn',
  },
  task: {
    new: 'Việc mới',
    newPersonal: 'Thêm việc cá nhân',
    titleField: 'Tiêu đề',
    description: 'Mô tả',
    project: 'Dự án',
    personal: 'Việc cá nhân',
    assignee: 'Người phụ trách',
    creator: 'Người giao',
    watchers: 'Người theo dõi',
    addWatcher: 'Thêm người theo dõi…',
    startOn: 'Bắt đầu',
    dueOn: 'Hạn',
    dueTime: 'Giờ',
    priority: 'Ưu tiên',
    labels: 'Nhãn',
    checklist: 'Checklist',
    addItem: 'Thêm mục…',
    files: 'File đính kèm',
    upload: 'Tải file lên',
    fileHint: 'PDF hoặc ảnh, tối đa 10 MB.',
    comments: 'Bình luận',
    commentPlaceholder: 'Viết bình luận… gõ @ để nhắc tên',
    send: 'Gửi',
    history: 'Lịch sử',
    created: 'Đã tạo việc',
    deleteConfirm: 'Xoá việc này?',
    deleteHint: 'Checklist, bình luận và file của việc cũng bị xoá.',
    deleted: 'Đã xoá việc',
    overdue: 'Quá hạn',
    number: 'Số',
    status: 'Trạng thái',
    events: {
      created: 'tạo việc',
      recurred: 'tạo việc theo lịch lặp',
      status: 'chuyển {{from}} → {{to}}',
      assignee: 'giao cho {{name}}',
      unassigned: 'bỏ người phụ trách',
      due: 'đổi hạn thành {{date}}',
      dueRemoved: 'bỏ hạn',
    },
  },
  repeat: {
    label: 'Lặp lại',
    none: 'Không lặp',
    frequency: { workday: 'Mỗi ngày làm việc', weekly: 'Hằng tuần', monthly: 'Hằng tháng' },
    weekdays: { 1: 'T2', 2: 'T3', 3: 'T4', 4: 'T5', 5: 'T6', 6: 'T7', 7: 'CN' },
    weekdaysLong: {
      1: 'thứ Hai',
      2: 'thứ Ba',
      3: 'thứ Tư',
      4: 'thứ Năm',
      5: 'thứ Sáu',
      6: 'thứ Bảy',
      7: 'Chủ nhật',
    },
    on: 'Vào các ngày',
    monthDay: 'Ngày trong tháng',
    monthDayHint: 'Tháng ngắn hơn thì lấy ngày cuối tháng.',
    every: 'Cách',
    everyWeeks: 'tuần',
    everyMonths: 'tháng',
    startOn: 'Bắt đầu từ',
    dueAfterDays: 'Hạn sau (ngày)',
    dueAfterHint: '0: hạn ngay trong ngày tạo việc.',
    checklist: 'Checklist (mỗi dòng một mục)',
    active: 'Đang chạy',
    paused: 'Tạm dừng',
    next: 'Lần tới',
    noNext: 'Không còn lần nào',
    last: 'Việc gần nhất',
    title: 'Việc lặp lại',
    description: 'Mỗi lần đến kỳ, hệ thống tạo một việc mới (0:10 sáng).',
    edit: 'Sửa lịch lặp',
    new: 'Việc lặp lại mới',
    created: 'Đã tạo việc lặp lại',
    deleteConfirm: 'Dừng hẳn việc lặp lại này?',
    deleteHint: 'Các việc đã tạo vẫn giữ nguyên.',
    deleted: 'Đã dừng việc lặp lại',
    empty: 'Chưa có việc lặp lại nào',
    badge: 'Lặp lại',
    weeklyText: '{{days}}',
    monthlyText: 'Ngày {{day}} hằng tháng',
    everyText: ', cách {{count}} {{unit}}',
  },
  board: {
    instructions:
      'Nhấn Space hoặc Enter để nhấc việc, dùng phím mũi tên để di chuyển, Space để thả, Esc để huỷ.',
    picked: 'Đã nhấc việc {{task}}.',
    over: 'Việc {{task}} đang ở cột {{target}}.',
    dropped: 'Đã thả việc {{task}} vào cột {{target}}.',
    cancelled: 'Đã huỷ kéo việc {{task}}.',
  },
  widget: {
    open: 'Mở',
    none: 'Không có việc nào cần làm',
    more: 'và {{count}} việc khác',
  },
  errors: {
    generic: 'Không thực hiện được. Thử lại sau.',
    'core.validation_failed': 'Thông tin chưa hợp lệ, kiểm tra các trường được đánh dấu.',
    'core.forbidden': 'Bạn không có quyền làm việc này.',
    'tasks.duplicate_key': 'Đã có dự án dùng mã này.',
    'tasks.key_locked': 'Dự án đã có việc nên không đổi được mã.',
    'tasks.assignee_not_member': 'Người phụ trách phải là thành viên dự án.',
    'tasks.unknown_label': 'Nhãn không thuộc dự án.',
    'tasks.unknown_user': 'Không tìm thấy người này.',
    'tasks.unknown_unit': 'Không tìm thấy đơn vị.',
    'tasks.move_not_allowed': 'Bạn không chuyển được việc sang trạng thái này.',
    'core-files.too_large': 'File quá lớn (tối đa 10 MB).',
    'core-files.unsupported_type': 'Chỉ nhận PDF hoặc ảnh (JPG, PNG, WebP).',
  },
};

export const en: typeof vi = {
  common: {
    loadError: 'Could not load data',
    retry: 'Retry',
    search: 'Search by number, title…',
    columns: 'Columns',
    export: 'Export CSV',
    cancel: 'Cancel',
    save: 'Save',
    saved: 'Saved',
    delete: 'Delete',
    add: 'Add',
    none: '—',
    nobody: 'Unassigned',
  },
  status: {
    todo: 'To do',
    doing: 'In progress',
    review: 'In review',
    done: 'Done',
    cancelled: 'Cancelled',
  },
  move: {
    todo: 'Back to To do',
    doing: 'Start',
    review: 'Send for review',
    done: 'Complete',
    cancelled: 'Cancel task',
    returnTitle: 'Send back',
    reopen: 'Reopen',
    returnHint: 'Say what needs fixing; the assignee will be notified.',
    reason: 'Reason',
    notAllowed: 'You cannot move this task to that column.',
  },
  priority: { low: 'Low', normal: 'Normal', high: 'High', urgent: 'Urgent' },
  mine: {
    title: 'My tasks',
    description: 'Tasks you do, give and follow, across projects.',
    assigned: 'Assigned to me',
    created: 'Given by me',
    watching: 'Following',
    recurring: 'Recurring',
    overdue: 'Overdue',
    today: 'Today',
    upcoming: 'Upcoming',
    noDue: 'No due date',
    empty: 'No tasks',
    showDone: 'Include done tasks',
  },
  projects: {
    title: 'Projects',
    description: 'Projects you are in or may see.',
    new: 'New project',
    edit: 'Edit project',
    key: 'Key',
    keyHint: '2–6 capitals or digits, the prefix of task numbers (MKT-12).',
    name: 'Name',
    descriptionField: 'Description',
    unit: 'Owning unit',
    unitHint: 'Unit heads may see the project.',
    public: 'Public in the company',
    publicHint: 'Everyone may read and comment; only members create and work.',
    archived: 'Archived',
    showArchived: 'Include archived projects',
    empty: 'No projects yet',
    managers: 'Managers',
    open: 'Open',
    overdueCount: '{{count}} overdue',
    progress: '{{done}}/{{total}} done',
    created: 'Project created',
    roles: { manager: 'Project manager', member: 'Member' },
    viewer: 'Viewer',
  },
  project: {
    board: 'Board',
    list: 'List',
    settings: 'Members & settings',
    members: 'Members',
    addMember: 'Add a member…',
    labels: 'Labels',
    addLabel: 'Add label',
    labelName: 'Label name',
    newTask: 'Add task',
    quickAdd: 'Add a task to this column…',
    readOnly: 'You are viewing this project (not a member).',
    filterAssignee: 'Everyone',
    filterLabel: 'All labels',
  },
  task: {
    new: 'New task',
    newPersonal: 'Add a personal task',
    titleField: 'Title',
    description: 'Description',
    project: 'Project',
    personal: 'Personal task',
    assignee: 'Assignee',
    creator: 'Given by',
    watchers: 'Watchers',
    addWatcher: 'Add a watcher…',
    startOn: 'Start',
    dueOn: 'Due',
    dueTime: 'Time',
    priority: 'Priority',
    labels: 'Labels',
    checklist: 'Checklist',
    addItem: 'Add an item…',
    files: 'Attachments',
    upload: 'Upload',
    fileHint: 'PDF or images, 10 MB max.',
    comments: 'Comments',
    commentPlaceholder: 'Write a comment… type @ to mention',
    send: 'Send',
    history: 'History',
    created: 'Task created',
    deleteConfirm: 'Delete this task?',
    deleteHint: 'Its checklist, comments and files go too.',
    deleted: 'Task deleted',
    overdue: 'Overdue',
    number: 'No.',
    status: 'Status',
    events: {
      created: 'created the task',
      recurred: 'made the task from its repeat schedule',
      status: 'moved {{from}} → {{to}}',
      assignee: 'assigned {{name}}',
      unassigned: 'removed the assignee',
      due: 'set the due date to {{date}}',
      dueRemoved: 'removed the due date',
    },
  },
  repeat: {
    label: 'Repeat',
    none: 'Does not repeat',
    frequency: { workday: 'Every working day', weekly: 'Weekly', monthly: 'Monthly' },
    weekdays: { 1: 'Mo', 2: 'Tu', 3: 'We', 4: 'Th', 5: 'Fr', 6: 'Sa', 7: 'Su' },
    weekdaysLong: {
      1: 'Monday',
      2: 'Tuesday',
      3: 'Wednesday',
      4: 'Thursday',
      5: 'Friday',
      6: 'Saturday',
      7: 'Sunday',
    },
    on: 'On',
    monthDay: 'Day of month',
    monthDayHint: 'Shorter months use their last day.',
    every: 'Every',
    everyWeeks: 'weeks',
    everyMonths: 'months',
    startOn: 'Starting',
    dueAfterDays: 'Due after (days)',
    dueAfterHint: '0: due the day it is made.',
    checklist: 'Checklist (one item per line)',
    active: 'Running',
    paused: 'Paused',
    next: 'Next',
    noNext: 'No more occurrences',
    last: 'Latest task',
    title: 'Recurring tasks',
    description: 'On each occurrence a new task is made (at 0:10).',
    edit: 'Edit the schedule',
    new: 'New recurring task',
    created: 'Recurring task created',
    deleteConfirm: 'Stop this recurring task for good?',
    deleteHint: 'Tasks already made stay.',
    deleted: 'Recurring task stopped',
    empty: 'No recurring tasks yet',
    badge: 'Repeats',
    weeklyText: '{{days}}',
    monthlyText: 'Day {{day}} of each month',
    everyText: ', every {{count}} {{unit}}',
  },
  board: {
    instructions:
      'Press Space or Enter to pick up a task, arrow keys to move it, Space to drop, Esc to cancel.',
    picked: 'Picked up task {{task}}.',
    over: 'Task {{task}} is over column {{target}}.',
    dropped: 'Dropped task {{task}} in column {{target}}.',
    cancelled: 'Dragging task {{task}} was cancelled.',
  },
  widget: {
    open: 'Open',
    none: 'Nothing to do',
    more: 'and {{count}} more',
  },
  errors: {
    generic: 'Could not complete. Try again later.',
    'core.validation_failed': 'Some information is invalid; check the highlighted fields.',
    'core.forbidden': 'You are not allowed to do this.',
    'tasks.duplicate_key': 'Another project uses this key.',
    'tasks.key_locked': 'The project has tasks; its key cannot change.',
    'tasks.assignee_not_member': 'The assignee must be a project member.',
    'tasks.unknown_label': 'The label is not from this project.',
    'tasks.unknown_user': 'Person not found.',
    'tasks.unknown_unit': 'Unit not found.',
    'tasks.move_not_allowed': 'You cannot move the task to that status.',
    'core-files.too_large': 'File too large (10 MB max).',
    'core-files.unsupported_type': 'Only PDF or images (JPG, PNG, WebP).',
  },
};
